// The zoom's pure half — 05i-2. main.js's 5 zoom steps and the slider maths, copied exactly.

export const SCALE_VALUES: readonly number[] = [0.5, 0.75, 1, 1.25, 1.5];
/** 100%. */
export const DEFAULT_ZOOM_IDX = 2;
/** The slider: 45px between dots, the first 10px down, the thumb 2px above its dot. */
const DOT_SPACING = 45;
const FIRST_DOT = 10;

/** A requested step, rounded and kept within the 5 (main.js setZoom). */
export function clampZoomIdx(idx: number): number {
  return Math.max(0, Math.min(SCALE_VALUES.length - 1, Math.round(idx)));
}

/** The step under the pointer, from its y inside the slider (unclamped — setZoom clamps). */
export function zoomIdxAt(yInWidget: number): number {
  return Math.round((yInWidget - FIRST_DOT) / DOT_SPACING);
}

/** The thumb's `top` for a step. */
export function thumbTop(idx: number): string {
  return idx * DOT_SPACING + 2 + "px";
}

/** The page's grid background, kept in step with the zoomed canvas: the tile size, and the
 *  offset that keeps the lines on the canvas's cells (56 = the side rail, 66 = the top bar +
 *  the canvas margin, less the zoomed half gap). */
export function gridBackground(scale: number, step: number): { size: string; position: string } {
  const gridStep = step * scale;
  return { size: `${gridStep}px ${gridStep}px`, position: `${56 - 5 * scale}px ${66 - 5 * scale}px` };
}
